// HorsSignal — informations agence & mentions légales (données officielles).
export const AGENCY = {
  name: "HorsSignal",
  legalForm: "Entrepreneur individuel",
  operator: "Theo PIQUOT, exerçant sous le nom commercial HorsSignal",
  siren: "942037516",
  siret: "942037516 00013",
  tva: "FR03942037516",
  address: "50 Avenue des Champs-Élysées, 75008 Paris",
  email: "contact@horssignal.com",
  phone: "+33 6 67 08 80 04",
  whatsapp: "33667088004",
  director: "Theo PIQUOT",
  host: "Emergent Labs Inc.",
  hostAddress: "2380 Via Espada, Pleasanton, CA 94566, États-Unis",
  atoutFrance: "IM014260001",
  guarantee: "AXA France IARD, 313 Terrasses de l'Arche, 92727 Nanterre Cedex — N° de garantie : GC-AXA-2026-047935",
  rcPro: "Chapka Assurances, contrat n° 084647485",
  founded: 2019,
};
